import { create } from "zustand";

/**
 * Frontend health status constants.
 */
export const API_HEALTH_STATUS = {
  /** Initial state, health check in progress */
  UNKNOWN: "unknown",
  /** All services healthy */
  OK: "ok",
  /** Connection issues, show warning banner */
  DOWN: "down",
  /** Client is offline */
  OFFLINE: "offline",
  /** Silent reconnection in progress (no banner) */
  RECONNECTING: "reconnecting",
} as const;

export type ApiHealthStatus = (typeof API_HEALTH_STATUS)[keyof typeof API_HEALTH_STATUS];
export type ApiHealthSource = "sse" | "offline" | null;

interface ApiHealthState {
  status: ApiHealthStatus;
  source: ApiHealthSource;
  isChecking: boolean;
  setStatus: (status: ApiHealthStatus, source: ApiHealthSource) => void;
  setChecking: (isChecking: boolean) => void;
}

export const useApiHealthStore = create<ApiHealthState>((set) => ({
  status: "unknown",
  source: null,
  isChecking: true,
  setStatus: (status, source) => set({ status, source }),
  setChecking: (isChecking) => set({ isChecking }),
}));
